import { render, staticRenderFns } from "./Administrador.vue?vue&type=template&id=307188f2&scoped=true&"
import script from "./Administrador.vue?vue&type=script&lang=js&"
export * from "./Administrador.vue?vue&type=script&lang=js&"
import style0 from "./Administrador.vue?vue&type=style&index=0&id=307188f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307188f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDataTable,VRow})
